import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK, AUTH_GET_PERMISSIONS } from 'admin-on-rest';
import decodeJwt from 'jwt-decode';
import { userIs } from '../util'

export default ( restTokenURL ) => {
	const authClientFunc = (type, params) => {
	    if (type === AUTH_LOGIN) {
	        const { username, password } = params;
	        const request = new Request( restTokenURL, {
	            method: 'POST',
	            body: JSON.stringify({ username, password }),
	            headers: new Headers({ 'Content-Type': 'application/json' }),
	        })
	        return fetch(request)
	            .then(response => {
	                if (response.status < 200 || response.status >= 300) {
	                    throw new Error(response.statusText);
	                }
	                return response.json();
	            })
	            .then(({ token }) => {
					const decodedToken = decodeJwt(token);
	                localStorage.setItem('token', token);
					localStorage.setItem('user_id', decodedToken.data.user.ID );
					localStorage.setItem('email', decodedToken.data.user.email );
					localStorage.setItem('name', decodedToken.data.user.name );
					localStorage.setItem('is_sales_support_head', decodedToken.data.user.is_sales_support_head );
					localStorage.setItem('role', decodedToken.data.user.role );
					localStorage.setItem('roles', JSON.stringify( decodedToken.data.user.roles ) );
					localStorage.setItem('available_reports', JSON.stringify( decodedToken.data.user.available_reports ) );
					localStorage.setItem('dealerships', JSON.stringify( decodedToken.data.user.dealerships ) );

					// This is based in the resources in App.js
					if ( ! userIs( 'dc' ) && ! userIs( 'collector' ) ) {
						if ( userIs( 'sales_support_head' ) ) {
							window.location.href = `/report_sales_support_team_incentive`
						} else if ( userIs( 'report', 'dealership_performance' ) ) {
							window.location.href = `/report_dealership_performance`
						} else if ( userIs( 'report', 'sales_support_team_incentive' ) ) {
							window.location.href = `/report_sales_support_team_incentive`
						} else if ( userIs( 'report', 'cc_officer_incentive' ) ) {
							window.location.href = `/report_cc_officer_incentive`
						} else if ( userIs( 'report', 'collections' ) ) {
							window.location.href = `/report_collections_dealership`
						} else if ( userIs( 'report', 'bank_collections' ) ) {
							window.location.href = `/report_bank`
						} else if ( userIs( 'report', 'documentation_performance' ) ) {
							window.location.href = `/report_documentation_performance`
						}
					}

	            });
	    }
		if (type === AUTH_LOGOUT) {
	        localStorage.removeItem('token');
	        localStorage.removeItem('roles');
	        localStorage.removeItem('email');
	        localStorage.removeItem('name');
			localStorage.removeItem('user_id');
			localStorage.removeItem('is_sales_support_head');
			localStorage.removeItem('role');
			localStorage.removeItem('available_reports');
			localStorage.removeItem('dealerships');
	        return Promise.resolve();
	    }
		// called when the API returns an error
	    if (type === AUTH_ERROR) {
	        const { status } = params;
	        if (status === 401 || status === 403) {
	            localStorage.removeItem('token');
	            localStorage.removeItem('roles');
	            localStorage.removeItem('email');
	            localStorage.removeItem('name');
	            localStorage.removeItem('user_id');
	            localStorage.removeItem('is_sales_support_head');
	            localStorage.removeItem('role');
	            localStorage.removeItem('available_reports');
	            localStorage.removeItem('dealerships');
	            return Promise.reject();
	        }
	        return Promise.resolve();
	    }
	    // called when the user navigates to a new location
	    if (type === AUTH_CHECK) {
	        return localStorage.getItem('token') ? Promise.resolve() : Promise.reject();
	    }
		if (type === AUTH_GET_PERMISSIONS) {
			let role = [], reports = [], user_id = null
			if ( localStorage.getItem( 'token' ) ) {
				user_id = localStorage.getItem('user_id')
				role = [...(new Set([
					localStorage.getItem('role'),
					...JSON.parse( localStorage.getItem('roles') ),
					...( localStorage.getItem('is_sales_support_head') ? [ 'sales_support_head' ] : [] ),
				]))]
				reports = [
					...JSON.parse( localStorage.getItem('available_reports') ),
				]
			}
			const roles = {
				role,
				reports,
				user_id,
			}
			return Promise.resolve(roles);
		}
		return Promise.reject('Unkown method');
	}
	return authClientFunc
}



// WEBPACK FOOTER //
// ./src/rest/authClient.js